<template>
  <div class="sa-card">
    <label class="sa-diagno-label"> Assessment </label>
    <div class="sa-row sa-med-tab-cnt">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
            <p>Primary diagonosis</p>
            <div v-for="(n,i) in assesment.primary" :key="i" class="sa-card sa-card-gray sa-card-noshadow">
                <div :ref="presDiag" @click="openToggle(i)" :class="open[i]?'active':''" class="sa-cursor sa-word-break">
                    {{n.problem}}
                    <span  :class="{ 'icon-plus sa-added-med': !open[i], 'icon-minus sa-added-med': open[i] }"></span>
                </div>
                <transition>
                    <div class="sa-pre-acc-cnt" v-show="open[i]">
                        <div class="sa-row sa-med-tab-cnt">
                            <div class="sa-col-lg12 sa-med-tab-cnt">
                                <label>Onset</label>
                                <span>{{n.onset}}</span>
                            </div>
                            <div class="sa-col-lg12 sa-med-tab-cnt">
                                <label>Problem Note</label>
                                <span>{{n.problem_note}}</span>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div  class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
            <p>Secondary diagonosis</p>
            <div v-for="(n,i) in assesment.secondary" :key="i" class="sa-card sa-card-gray sa-card-noshadow">
                <div :ref="presDiag1" @click="openToggle1(j)" :class="open1[j]?'active':''" class="sa-cursor sa-word-break">
                    {{n.problem}}
                    <span  :class="{ 'icon-plus sa-added-med': !open1[j], 'icon-minus sa-added-med': open1[j] }"></span>
                </div>
                <transition>
                    <div class="sa-pre-acc-cnt" v-show="open1[j]">
                        <div class="sa-row sa-med-tab-cnt">
                            <div class="sa-col-lg12 sa-med-tab-cnt">
                                <label>Onset</label>
                                <span>{{n.onset}}</span>
                            </div>
                            <div class="sa-col-lg12 sa-med-tab-cnt">
                                <label>Problem Note</label>
                                <span>{{n.problem_note}}</span>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div  class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
            <p>Additional diagonosis</p>
            <div v-for="(n,i) in assesment.additional" :key="i" class="sa-card sa-card-gray sa-card-noshadow">
                <div :ref="presDiag2" @click="openToggle2(k)" :class="open2[k]?'active':''" class="sa-cursor sa-word-break">
                    {{n.problem}}
                    <span  :class="{ 'icon-plus sa-added-med': !open2[k], 'icon-minus sa-added-med': open2[k] }"></span>
                </div>
                <transition>
                    <div class="sa-pre-acc-cnt" v-show="open2[k]">
                        <div class="sa-row sa-med-tab-cnt">
                            <div class="sa-col-lg12 sa-med-tab-cnt">
                                <label>Onset</label>
                                <span>{{n.onset}}</span>
                            </div>
                            <div class="sa-col-lg12 sa-med-tab-cnt">
                                <label>Problem Note</label>
                                <span>{{n.problem_note}}</span>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    props:["assesment"],
    data(){
        return{
            i:null,
            j:null,
            k:null,
            presDiag: 0,
            presDiag1: 0,
            presDiag2: 0,
            open: {},
            open1: {},
            open2: {},
        }
    },
    methods:{
        openToggle(i) {
            let _self = this
            let flag = !_self.open[i]
            _self.$set(_self.open, i, flag)
            _self.presDiag += 1
        },
        openToggle1(j) {
            let _self = this
            let flag = !_self.open1[j]
            _self.$set(_self.open1, j, flag)
            _self.presDiag1 += 1
        },
        openToggle2(k) {
            let _self = this
            let flag = !_self.open2[k]
            _self.$set(_self.open2, k, flag)
            _self.presDiag2 += 1
        },
    }
};
</script>